($ => {

    $(async () => {
        Events.listen(ServerEvents.REMOVE_PALESTRANTE_ORCAMENTO, (event, dataHTML) => {
            let pageHTML = $.parseHTML(dataHTML);
            let cardsHTML = $(".sidebar-cesta-orcamento", pageHTML).html();
            if (cardsHTML !== undefined) {
                $(".sidebar-cesta-orcamento").html(cardsHTML);
            }
        });
    });

})(jQuery);
